/**
 * StorePicker: the store a HO kitchen screen is about (stations and routing need one, ADR 0027). A searchable
 * ComboBox over the stores. Props: `value` (store id or ''), `onChange(id)`.
 */
import { useTranslation } from '@pos/i18n';
import { ReferenceComboBox } from '../fields/ReferenceComboBox';

export function StorePicker({ value, onChange }: { value: string; onChange(id: string): void }) {
  const { t } = useTranslation();
  // Searches on the server for a large fleet (thousands of stores).
  return (
    <ReferenceComboBox
      id="kitchen-store-picker"
      titleText={t('admin.kitchen.store')}
      placeholder={t('admin.kitchen.storePlaceholder')}
      resourceKey="org.store"
      value={value || null}
      onChange={(next) => onChange(next ?? '')}
    />
  );
}
